'use client';

import { createFileRoute } from '@tanstack/react-router';
import GeneralStatusError from 'src/components/StatusError/General';

export const Route = createFileRoute('/_admin/404')({
	validateSearch: (search: Record<string, unknown>) => {
		return {
			occurredAt: (search.occurredAt as string) || undefined,
			method: (search.method as string) || undefined,
			uuid: (search.uuid as string) || undefined,
		};
	},
	component: NotFoundPage,
});

function NotFoundPage() {
	const { occurredAt, method, uuid } = Route.useSearch();

	return (
		<GeneralStatusError
			illustrationSrc="/public/empty_box.svg"
			label="We couldn't find the requested resource"
			occurredAt={occurredAt}
			method={method}
			uuid={uuid}
			action={{
				label: 'Go back to previous page',
				onClick: () => {
					window.history.back();
				},
			}}
		/>
	);
}
